import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { ReactSVG } from "react-svg";
import LockIcon from "Assets/svg/icon/Lock_nv.svg";
import LockOpenIcon from "Assets/svg/icon/unlock_nv.svg";

function IsLockFormatter({ cell }) {
  return (
    <>
      {cell ? (
        <Tooltip title="قفل" placement="bottom">
          {<ReactSVG src={LockIcon} className="justIcon lock-icon" />}
        </Tooltip>
      ) : (
        <Tooltip title="قفل نیست" placement="bottom">
          {<ReactSVG src={LockOpenIcon} className="justIcon unlock-icon" />}
        </Tooltip>
      )}
    </>
  );
}

export default IsLockFormatter;
